import { createFileRoute } from '@tanstack/react-router'

import { InvoicingBalanceDocumentationPage } from '../../../../components/pages/backoffice/platform/platform-documentation/invoicing-balance-documentation-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/documentation/invoicing-balance')({
  component: () => (
    <PermissionChecker requiredPermissions={['documentation.read']}>
      <InvoicingBalanceDocumentationPage />
    </PermissionChecker>
  ),
})
